// componente che intercetta tutte le richieste HTTP che entrano nell'applicativo ed esegue il logout
// nel caso in cui si riceve un "401 Unauthorized" dal back-end

import {Injectable} from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {AuthenticationService} from '../service/authentication.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {UtilsService} from '../service/helper/utils.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private snackBar: MatSnackBar,
        private utilsService: UtilsService,
    ) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const API_HOST_URL = 'https://sosimperium.multiutilitydelgarda.eu:8001';

        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                this.authenticationService.logout();
            }

            const error = err.statusText || err.message || err.error && err.error.message || 'Unexpected error occurred!';
            this.snackBar.open(error, undefined, {
                panelClass: ['errorSnackbar']
            });

            this.utilsService.hideLoader();

            if (request.url === `${API_HOST_URL}/login`){
                request.clone();
            }

            return throwError(`Error: ${error}`);
        }));
    }
}
